// * ========================================================================
// * Show more file inputs when files are added to feedback form
// * ========================================================================

'use strict';

import $ from 'jquery';

var showInputs = (function() {
  function init(){
    $('.js-feedback-file-input input').on('change',function(){
      $(this).parents('.js-feedback-file-input').next().removeClass('hidden');
    });
  }
  return {
    init: init
  }
})();

module.exports = showInputs;
